module.exports = __webpack_public_path__ + "assets/images/smoke_y.2e3547c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/smoke_y.png
// module id = 767
// module chunks = 1